export default __webpack_public_path__ + "static/media/10.c2682501.jpg";